<template>
	<div class="onlineExam">
	    <div class="onlineExam_center">
			<div class="onlineExam_center" style="display: flex;justify-content: space-between; align-items: center;">
				<div class="title">考试题目</div>
				<div>
					<el-button style="background-color: #C41515;border: #C41515; margin-right: 40px;" type="primary" @click="$router.go(-1)">返回</el-button>
				</div>
			</div>
            <div class="onlineExam_center_top">
                <span>题目数：{{ allQuestion.length }}</span>
                <span>考试时长：{{ durationTime }}分钟</span>
                <!-- <span>考试时间：{{ allQuestion.length }}</span> -->
                <span>卷面总分：{{ totalStore }}</span>
                <span>及格分数：{{ passSrore }}</span>
                <span>得分：{{ com_number }}</span>
			</div>
			<div class="onlineExam_question_List">
                <div class="onlineExam_question_List_left2">
					<!-- 单选 -->
					<div class="questionList_item" v-for="(item,i) in allQuestion" :key="item.qid">
						<!-- 标题 -->
						<div class="questionList_item_top_title">
                            {{i+1}}、{{ item.title }}({{ item.type }}) 
						</div>
						<div class="question_options"  v-for="(items) in item.option">
							<div class="question_options_item">
								{{ items.title }} : {{ items.content }}
							</div>
							
						</div>
						<div class="question_options_item" style="margin-top: 20px;">
								<span style="margin-right: 20px;">你的选项：{{ item.com_answer }}</span>
								<span style="color: red;">正确答案：{{ item.answer }}</span>
						</div>
						<div class="question_options_item" style="margin-top: 20px;">
								题目解析：{{ item.analysis }}
						</div>
						
					</div>
				</div>
             
			</div>
		</div>
	</div>
</template>
<script>
	import { user } from '@/axios';
	export default{
		data(){
			
			return{
				getdata:{
					uid:this.$store.state.user.userinfo2.id,
					tid:this.$route.query.tid,
					aid:this.$route.query.aid,
				},
				datacheng:[],
				singleList:[],
				moreList:[],
				judgeList:[],
				allQuestion:[],
				totalStore:'',
				passSrore:'',
				durationTime:'',
				com_number:'',
				singleCheck:[],
				moreCheck:[],
                submitDate:[]

			}
		},
		
		methods:{
			
			
			// 获取试卷详情
			getExamDetail(){
				let that=this
				user.ExamDetail(that.getdata).then(res=>{
					if (res.code==200) {
								that.singleList=res.data.single
						that.singleList.forEach((item,index,arr) => {
							arr[index].type='单选'
						
							
						});
						that.moreList=res.data.more
						that.moreList.forEach((item,index,arr) => {
							arr[index].type='多选'
						
							
						});
						that.judgeList=res.data.judge
						that.judgeList.forEach((item,index,arr) => {
							arr[index].type='判断'
						
						});
						that.passSrore=res.data.pass
						that.durationTime=res.data.duration
						that.totalStore=res.data.total 
						that.com_number=res.data.com_number 
						
                        that.allQuestion=[...that.singleList,...that.moreList,...that.judgeList]
				
					}
				})
			},
			
			
		  },
		mounted(){
			this.getExamDetail()
		},
		created() {
			this.$emit("highLight",0,"","","");
		}
	}
</script>

<style lang="scss">
.onlineExam{
	.question_options_item{
		color: #606266;
       font-weight: 500;
	   font-size: 14px;
	   line-height: 26px;
	   text-align: justify; /* 浏览器可能不支持 */
       letter-spacing: 1px;
	}
	width: 100%;
	height: 100%;
	background-color: #F9F9F9;
	min-height: 400px;
	.onlineExam_center{
		padding-top: 10px;
		width: 1200px;
		margin: 0 auto;
		
		.title{
			margin-top: 10px;
			height: 40px;
			line-height: 40px;
			font-weight: bold;
			font-size: 18px;
			color: #202020;
		}
		.onlineExam_center_top{
			display: flex;
			justify-content: space-between;
			width: 100%;
			height: 20px;
			font-family: PingFangSC-Regular;
			font-size:16px;
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;

			color: #999999;
			margin-bottom: 30px;
		}
		.onlineExam_question_List{
			width: 100%;
			display: flex;
			justify-content: space-between;
			.onlineExam_question_List_left2{
				width: 1200px;
				
				.questionList_item{
					margin-bottom: 30px;
					box-sizing: border-box;
					padding: 20px;
					width: 100%;
					background-color: #fff;
                   .questionList_item_top_title{
					color: #1E2129;
					font-size: 14px;
					font-weight: bold;
					margin-bottom: 15px;
				   }
				   .question_options{
					margin-top: 15px;
				   }
					
					
				}
			}
			.onlineExam_question_List_right{
				width: 288px;
				height: 350px;
				background-color: #fff;
				.onlineExam_question_List_right_top{
					width: 100%;
					height: 35px;
					background-color: #EE632B;
					color: #fff;
					font-size: 20px;
					line-height: 35px;
					text-align: center;
				}
				.onlineExam_question_List_right_bottom{
					width: 100%;
					height: 315px;
					overflow-y: auto;
					box-sizing: border-box;
					padding: 10px;
					display: flex;
					flex-wrap: wrap;
					align-content: start;
                    .answer_item{
						margin-right: 20px;
                        width: 32px;
						height: 32px;
						border: 1px solid rgb(206,0,13);
						border-radius: 4px;
						color: #333;
						font-size: 18px;
						text-align: center;
						line-height: 32px;
						margin-bottom: 20px;
					}
					.answer_item:nth-child(5n){
						margin-right: 0;
					}
				}
                 
			}
			
		}
		.submitExam{
			text-align: center;
			margin-bottom: 40px;
		}
	}
}
	
		
			
</style>
